<template>
  <div v-if="loggedIn" class="text-center">
    <v-btn
      small
      class="my-3 pa-2"
      @click="showComments = !showComments"
      color="primary"
      >{{ titleOnShowCommentsButton }}
    </v-btn>
    <div v-if="showComments">
      <CommentComponent
        v-for="comment in article.comments"
        :key="comment.id"
        :comment-id="comment.id"
        :author-id="comment.author_info.id"
        :author-name="comment.author_info.name"
        :author-avatar-filename="comment.author_info.avatar_filename"
        :text="comment.text"
        :pub-date="comment.pub_date"
        :article-id="article.id"
        @deletedata="deleteCommentHandler"
        @updatedata="updateCommentHandler"
      >
      </CommentComponent>
      <CommentComponent
        :author-id="loggedUserPersonId"
        :author-name="loggedUserPersonName"
        :author-avatar-filename="loggedUserAvatarFilename"
        :article-id="article.id"
        @adddata="addCommentHandler"
      ></CommentComponent>
    </div>
  </div>
</template>

<script>
import { showDate, declOfNum } from '@/helpers/helpers.js'
import { authComputed } from '@/store/helpers.js'
import Vue from 'vue'
import CommentComponent from '@/components/CommentComponent.vue'

export default {
  components: {
    CommentComponent
  },
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showComments: false
    }
  },
  computed: {
    ...authComputed,
    titleOnShowCommentsButton() {
      if (this.showComments) {
        return 'Скрыть комментарии'
      }

      if (this.article.comments.length == 0) {
        return 'Написать комментарий'
      }
      return (
        'Прочитать ' +
        this.article.comments.length +
        ' ' +
        declOfNum(this.article.comments.length, [
          'комментарий',
          'комментария',
          'комментариев'
        ])
      )
    }
  },
  methods: {
    showDate,
    declOfNum,
    addCommentHandler(comment) {
      console.log('add comment', comment)
      this.article.comments.push(comment)
    },

    updateCommentHandler(comment) {
      var foundIndex = this.article.comments.findIndex(x => x.id == comment.id)
      Vue.set(this.article.comments, foundIndex, comment) //специальная функци для обеспечения реактивности прри апдейте элемента массива
    },

    deleteCommentHandler(commentId) {
      var list = this.article.comments.filter(x => {
        return x.id != commentId
      })

      this.article.comments = list
    }
  }
}
</script>

<style></style>
